import { Injectable } from '@angular/core';
import axios from 'src/app/Service/axios';
import { ReportContext, ReportDefinition } from '../../report.models';
import { DeviceEventsResponse } from './device-events-report.models';
import { DataService } from 'src/app/Service/data.service';

@Injectable({ providedIn: 'root' })
export class DeviceEventsReportApiService {
  constructor(private readonly dataService: DataService) {}
  async load(definition: ReportDefinition, context: ReportContext, user: string, session: string, eventType: string): Promise<DeviceEventsResponse> {
    const payload = { strSDate: context.startDate, strUnitID: context.id, strEDate: context.endDate, iSystemUser: user,
      ...(context.type === '7' ? { strSession: session, tiDeviceEventsType: eventType } : context.type === '8' ? { strSession: session } : {}) };
    const response = await axios.post(definition.endpoint!, payload);
    const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    if (Array.isArray(data) || data?.ISSessionExpired || data?.ISessionExpired) return data;
    throw new Error('Unexpected device report response');
  }
  cacheInputs(rows: DeviceEventsResponse): void {
    if (Array.isArray(rows)) this.dataService.gpsIoData = rows;
  }
}
